
export default function About() {
    return (
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10 sm:py-14">
            <header>
                <p className="eyebrow">About Us</p>
                <h1 className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight mt-2 leading-tight">
                    A specialised typing tutor for English &amp;{" "}
                    <span className="font-nepali text-[var(--lt-terracotta)]">
                        नेपाली
                    </span>
                </h1>
            </header>

            <section className="mt-10 space-y-6 text-[var(--lt-text)] leading-relaxed">
                <p>
                    <strong>LipiTyping</strong> is a specialised bilingual typing
                    tutor dedicated to teaching English and Traditional Nepali
                    (Devanagari) touch typing. We built LipiTyping because most
                    typing tools either ignore Devanagari entirely or rely on
                    Romanised shortcuts that never translate to real professional
                    speed.
                </p>
                <p>
                    Our platform maps the Traditional Nepali keyboard directly onto
                    your familiar QWERTY layout, so the same physical keys you use
                    every day become a bridge into fluent Devanagari input. No OS
                    switch, no external software, no compromises.
                </p>

                <h2 className="text-xl sm:text-2xl font-semibold mt-10">What we offer</h2>
                <ul className="list-disc pl-6 space-y-2 text-[var(--lt-muted)]">
                    <li>
                        <span className="text-[var(--lt-text)] font-semibold">
                            Structured lessons
                        </span>{" "}
                        — from the home row to full paragraphs, in both scripts.
                    </li>
                    <li>
                        <span className="text-[var(--lt-text)] font-semibold">
                            Timed speed tests
                        </span>{" "}
                        — 30-, 60- and 120-second runs with instant analysis.
                    </li>
                    <li>
                        <span className="text-[var(--lt-text)] font-semibold">
                            A shared leaderboard
                        </span>{" "}
                        — separate ranks for English and Traditional Nepali.
                    </li>
                    <li>
                        <span className="text-[var(--lt-text)] font-semibold">
                            Nepal-focused utilities
                        </span>{" "}
                        — date conversion, gold &amp; silver rates, forex, fuel
                        prices, weather and festival calendar.
                    </li>
                </ul>

                <h2 className="text-xl sm:text-2xl font-semibold mt-10">Our mission</h2>
                <p>
                    We believe every Nepali student, professional, and content
                    creator deserves a first-class typing tool designed for their
                    language — not translated from someone else's. LipiTyping is
                    built with that principle at its core, and we intend to keep it
                    free of paywalls for individual learners.
                </p>

                <h2 className="text-xl sm:text-2xl font-semibold mt-10">
                    Who is behind this?
                </h2>
                <p>
                    LipiTyping is an independent product built by a small team of
                    engineers and educators who wanted a better answer to a very
                    specific question: “How does one actually learn Devanagari touch
                    typing in 2026?” If you have ideas, feedback or want to help,{" "}
                    <a
                        href="/contact"
                        className="text-[var(--lt-terracotta)] font-semibold hover:underline"
                    >
                        say hello on the contact page
                    </a>
                    .
                </p>
            </section>
        </div>
    );
}
